import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { TopProductsRankingCompareEntry } from '@/components/ReviewsManagement/TopProductsRanking/types'

export const persistKey = 'omr-manage-top-products-ranking-compare-v1'

export const useTopProductsRankingCompareStore = defineStore(
  'topProductsRankingCompare',
  () => {
    const selections = ref<Record<string, TopProductsRankingCompareEntry[]>>({})

    function add(productSlug: string, entry: TopProductsRankingCompareEntry): boolean {
      const current = selections.value[productSlug] ?? []
      if (current.some((selected) => selected.tool === entry.tool)) return false
      selections.value = { ...selections.value, [productSlug]: [...current, { ...entry, storedAt: new Date().toISOString() }] }
      return true
    }

    function remove(productSlug: string, tool: string) {
      const next = (selections.value[productSlug] ?? []).filter((selected) => selected.tool !== tool)
      const { [productSlug]: dropped, ...rest } = selections.value
      selections.value = next.length ? { ...rest, [productSlug]: next } : rest
    }

    function refresh(productSlug: string, visible: TopProductsRankingCompareEntry[]) {
      const current = selections.value[productSlug]
      if (!current?.length || !visible.length) return
      const byTool = new Map(visible.map((entry) => [entry.tool, entry]))
      if (!current.some((selected) => byTool.has(selected.tool))) return
      selections.value = {
        ...selections.value,
        [productSlug]: current.map((selected) => {
          const fresh = byTool.get(selected.tool)
          return fresh ? { ...fresh, storedAt: new Date().toISOString() } : selected
        }),
      }
    }

    function reset() {
      selections.value = {}
    }

    return { selections, add, remove, refresh, reset }
  },
  { persist: { key: persistKey, pick: ['selections'], storage: localStorage } },
)
